import type { PodBrand } from '@/types/pod'

/**
 * Kelvo demo pod — branding layer (browser side). Kelvo build step 2, item 5.
 *
 * The first STAFF surface: served on kelvo.autaimate.com behind a Clerk login,
 * for the firm's own office staff, site staff and owner. Nothing here is shown
 * to the public.
 *
 * EVERY WORD IS HONEST ABOUT AN EMPTY CORPUS. The pod ships with no documents
 * (see pods/kelvo-demo/system-prompt.ts), so the welcome promises what the
 * product does with a gap — says so, and the question reaches the office —
 * rather than implying answers exist. The starters are real questions a builder's
 * staff ask; on the demo they show the honest "not written down yet" reply,
 * which is the loop the product sells.
 *
 * THE FOOTER CARRIES THE SITE-SAFETY LINE on purpose: it is on screen for every
 * question, including the one asked in a hurry, and it points to a person.
 *
 * PALETTE: slate with a safety-amber accent — reads as construction without
 * being a hi-vis costume. Text colours meet WCAG AA on their surfaces:
 * text-primary 15 23 42 on white is 17.9:1, text-muted 71 85 105 on white is
 * 7.6:1, white on brand-primary 30 41 59 is 14.6:1.
 */
export const kelvoDemoPod: PodBrand = {
  id: 'kelvo-demo',
  surface: 'staff',
  brandName: 'Demo Builders',
  productName: 'Kelvo',
  assistantName: 'Kelvo',
  tagline: 'How we work, in one place.',
  roleLabel: 'office assistant',
  welcomeIntro:
    'Ask me anything about how Demo Builders works \u2014 a procedure, a RAMS, a template, a price or a site rule. If it isn\u2019t written down yet I\u2019ll tell you straight, and the office will see the question.',
  starters: [
    'How do I report a near miss?',
    'What PPE do we need on a roofing job?',
    'Where\u2019s the RAMS template?',
  ],
  inputPrompt: 'Ask Kelvo',
  footerNote:
    'Kelvo answers only from Demo Builders\u2019 own documents. Anything urgent on site: speak to your supervisor.',
  theme: {
    '--color-brand-primary': '30 41 59',
    '--color-brand-primary-hover': '15 23 42',
    '--color-brand-accent': '245 158 11',
    '--color-surface-base': '248 250 252',
    '--color-surface-raised': '255 255 255',
    '--color-surface-subtle': '241 245 249',
    '--color-text-primary': '15 23 42',
    '--color-text-muted': '71 85 105',
    '--color-text-danger': '185 28 28',
    '--color-border-subtle': '226 232 240',
  },
  // No contact block: the person asking works here. "Speak to your supervisor"
  // and "that's one for the office" are the deferrals, not an email address.
  contact: {},
}
